import React from 'react';
import {Modal} from 'react-bootstrap';

export default function RecentPostsModal(props) {
    const {recentPostsModal, handleNextPostClick, handleRecentPostsModalHide} = props;

    const {show, bio, posts, currentPostIndex} = recentPostsModal;

    const currentPost =
        posts && posts.length > 0 && currentPostIndex > -1 ? posts[currentPostIndex] : null;

    const postContainer = currentPost ? (
        <div className="post-ctn">
            <a target="_blank" rel="noopener noreferrer" href={currentPost.link}>
                <img className="post-image" src={currentPost.url} />
            </a>
            <div className="post-text col-xs-12">
                <br />
                <div>
                    {'Profile Bio:'}
                    <p>{bio}</p>
                </div>
                <br />
                <div>
                    {'Caption:'}
                    <p>{currentPost.caption}</p>
                </div>
                <br />
                <div>{`Likes: ${currentPost.likes}`}</div>
                <div>{`Comments: ${currentPost.comments}`}</div>
                <br />
                <div className="col-xs-offset-2 col-xs-12">
                    <button
                        className="recent-posts-next btn btn-primary"
                        onClick={e => handleNextPostClick(e)}
                    >
                        {'Next Post'}
                    </button>
                </div>
            </div>
        </div>
    ) : (
        <div className="post-ctn">{'User has no recent posts!'}</div>
    );

    return (
        <Modal show={show} onHide={handleRecentPostsModalHide}>
            {postContainer}
        </Modal>
    );
}



// WEBPACK FOOTER //
// ./execution/shared_components/recent_posts_modal.js